import { useState, useEffect, useContext, useRef } from "react";
import {
  Table,
  TableContainer,
  TableHead,
  TableBody,
  TableCell,
  TableRow,
} from "@material-ui/core";
import { TitleCard, CollapseRow, TopButtons } from "../../../components/index";
import { AuthContext } from "../../../auth/AuthHandler";
import { ReleaseTrackerDataService } from "../../../data/ReleaseTrackerDataService";
import { useBreadcrumb } from "../../../hooks/useBreadcrumb";
import { checkName, checkUrlName } from "../../../helper/checkName";

export default function Product({ match }) {
  const authCtx = useContext(AuthContext);
  const { locks_or_peripherals: deviceType, url: familyName } = match.params;

  const [firmwares, setFirmwares] = useState([]);
  const relTrackerRef = useRef(null);

  // breadcrumbs: Dashboard > Firmware > deviceType > familyName
  useBreadcrumb(
    [
      { label: "Home", path: "/" },
      { label: "Firmware", path: "/firmware" },
      { label: checkUrlName(deviceType), path: `/firmware/${deviceType}` },
      { label: checkName(familyName) },
    ],
    [deviceType, familyName],
  );

  useEffect(() => {
    relTrackerRef.current = new ReleaseTrackerDataService(authCtx);

    relTrackerRef.current
      .getFirmwareFamiliesFirmwares(deviceType, familyName)
      .then((data) => {
        setFirmwares(data);
      })
      .catch((err) => {
        console.error(err);
      });
  }, [authCtx, deviceType, familyName]);

  const getVersions = (value, setVersions) => {
    if (!relTrackerRef.current)
      relTrackerRef.current = new ReleaseTrackerDataService(authCtx);

    relTrackerRef.current
      .getFirmwareFamiliesFirmwareVersions(deviceType, familyName, value.Name)
      .then((data) => {
        setVersions(data);
      })
      .catch((err) => {
        console.error(err);
        setVersions([]);
      });
  };

  let imgSrc;
  try {
    imgSrc = require("./../../../assets/img/" + familyName + ".jpg").default;
  } catch {
    imgSrc = undefined;
  }

  return (
    <div className="product">
      <TopButtons />
      <div className="product-title-section">
        {imgSrc === undefined ? "" : <TitleCard img={imgSrc} />}
        <h3>{checkName(familyName)}</h3>
      </div>
      <div className="product-subtitle">
        <p>Select version</p>
      </div>
      <div className="pTable">
        <TableContainer>
          <Table aria-label="collapsible table">
            <TableHead>
              <TableRow>
                <TableCell>Name</TableCell>
                <TableCell>Firmware Numbers</TableCell>
                <TableCell />
              </TableRow>
            </TableHead>
            <TableBody>
              {firmwares.map((value) => (
                <CollapseRow
                  key={value.Name}
                  name={value.Name}
                  num={value.FirmwareNumbers}
                  onOpen={(setVersions) => getVersions(value, setVersions)}
                />
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </div>
  );
}
